/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import PopEvaluationReport from './_PopEvaluationReport';

function EvaluationReport() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '전체', value: 0},
    {title: '승인 요청', value: 1},
    {title: '승인', value: 2, type: 'new'},
    {title: '미등록', value: 3, type: 'red'}
  ];
  const [modalEvaluationReport, setModalEvaluationReport] = useState(false);
  return (
    <main className="com_container p_evaluation_report">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu1_19">수업평가 보고서</h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalEvaluationReport(true)} className="com_btn orange s btn_plus">
              수업평가 등록
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <button className="com_btn s btn_request gray">내 작성목록</button>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <select className="select">
                <option value="과목 전체">과목 전체</option>
              </select>
              <section className="com_board_search">
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력" className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="4%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
                <col width="5%" />
                <col width="5%" />
                <col width="5%" />
                <col width="8%" />
                <col width="15%" />
                <col width="8%" />
                <col width="8%" />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>학생명</th>
                  <th>과목</th>
                  <th>회차</th>
                  <th>목표수능 등급</th>
                  <th>과제평가</th>
                  <th>수업태도</th>
                  <th>제목</th>
                  <th>교사</th>
                  <th>담임</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>12</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>가길동102(남/17)</td>
                  <td>언어</td>
                  <td>3</td>
                  <td>1</td>
                  <td>매우좋음</td>
                  <td>좋음</td>
                  <td className='td_left'>미작성</td>
                  <td>가길동102</td>
                  <td>가길동102</td>
                  <td className="td_red">
                    <button className="name btn_link">미작성</button>
                  </td>
                </tr>
                <tr>
                  <td>11</td>
                  <td className="td_date">2022.08.25 12:30</td>
                  <td>가길동102(남/17)</td>
                  <td>언어</td>
                  <td>3</td>
                  <td>1</td>
                  <td>매우좋음</td>
                  <td>좋음</td>
                  <td className='td_left'>(김담임) - 김학생이 개인 사정으로 </td>
                  <td>가길동102</td>
                  <td>가길동102</td>
                  <td className="td_red">
                    <button className="name btn_link">승인<br/>2023, 01, 05</button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className="td_date">2022.08.25 12:30</td>
                      <td>가길동102(남/17)</td>
                      <td>언어</td>
                      <td>3</td>
                      <td>1</td>
                      <td>매우좋음</td>
                      <td>좋음</td>
                      <td className='td_left'>개인사정으로 수업이 어렵다고 하네요</td>
                      <td>가길동102</td>
                      <td>가길동102</td>
                      <td className="td_point">
                        <button className="name btn_link">승인요청</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <button className="btn_edit" />
            </div>
            <table className="com_board_list type_row">
              <colgroup>
                <col width="148" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>학생명</th>
                  <td className="td_left">
                    <span className="name">홍길동202</span>(수학1Tㆍ고1)
                  </td>
                </tr>
                <tr>
                  <th>교사 / 담임</th>
                  <td className="td_left">김교사103 / 김담임120</td>
                </tr>
                <tr>
                  <th>최근 / 목표 수능등급</th>
                  <td className="td_left">6등급 / 3등급</td>
                </tr>
                <tr>
                  <th>평가기간</th>
                  <td className="td_left">2022, 08, 25 ~ 2022, 09, 15</td>
                </tr>
                <tr>
                  <th>진행 수업수</th>
                  <td className="td_left">
                    <div className="com_btn_wrap pick_date">
                      <button className="com_btn xxs active btn_class">2023.8.10</button>
                      <button className="com_btn xxs btn_class">2023.9.10</button>
                      <button className="com_btn xxs btn_class">2023.10.10</button>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>과제물 평가</th>
                  <td className="td_left">좋음</td>
                </tr>
                <tr>
                  <th>수업태도</th>
                  <td className="td_left">매우좋음</td>
                </tr>
                <tr>
                  <th rowSpan={2}>수업성취도</th>
                  <td className="td_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`생명과학1`} />
                      <input type="text" className="input" defaultValue={`진도 100`} />
                      <input type="text" className="input" defaultValue={`성취도 80`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="td_left border_left">
                    <div className="com_input_wrap flex_row">
                      <input type="text" className="input" defaultValue={`생명과학1`} />
                      <input type="text" className="input" defaultValue={`진도 100`} />
                      <input type="text" className="input" defaultValue={`성취도 80`} />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>지급 교재</th>
                  <td className="td_left">
                    [고3] 기출리허설 생활과윤리 (2024학년도) <br />
                    [고3] 기출리허설 생활과윤리 (2024학년도)
                    <br />
                    [고3] 기출리허설 생활과윤리 (2024학년도)
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="com_board_box">
              <div className="board_item">
                <p className="cont bold">현재상황</p>
                <hr className="com_divider" />
                <div className="info">
                  <textarea name="" className="textarea" placeholder="내용 입력 (취약유형및 수업방향)" />
                </div>
                <p className="cont bold">개선상황</p>
                <hr className="com_divider" />
                <textarea name="" className="textarea" placeholder="내용 입력" />
              </div>
              <div className="board_item">
                <div className="info">
                  <span className="cont">
                    <button className="name">김관리103</button>
                    <span className="desc dot">2025, 05, 20 11 : 30</span>
                  </span>
                  <div className="btn_wrap">
                    <button className="btn_edit"></button>
                    <button className="btn_delete"></button>
                  </div>
                </div>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_comment_wrap type_board short">
              <div className="comment_input">
                <textarea type="text" className="textarea" placeholder="댓글을 입력해주세요" />
                <button className="com_btn gray l">등록</button>
              </div>
            </div>
          </section>
        </section>
      </div>
      <PopEvaluationReport open={modalEvaluationReport} close={() => setModalEvaluationReport(false)} />
    </main>
  );
}

export default EvaluationReport;
